import moment from 'moment-timezone';
import 'moment-timezone';

// sorry.  This is an ugly hack to reformat the json date into
// cst format so that the browser understands that the date
// the db is storing is in central time.
export function convertDateToUnixTime(mydate) {
  let cstCorrection = mydate.toString();

  if (cstCorrection.indexOf('T') > 0) {
    if (isDstObserved()) {
      cstCorrection = cstCorrection.replace('T', ' ').replace('Z', ' ') + 'CDT';
    } else {
      cstCorrection = cstCorrection.replace('T', ' ').replace('Z', ' ') + 'CST';
    }
  }

  if (Number.isNaN(Date.parse(cstCorrection))) {
    const dateParts = cstCorrection.split('-');
    const timeParts = dateParts[2].split(' ')[1].split(':');

    const day = dateParts[2].split(' ')[0];
    const month = dateParts[1];
    const year = dateParts[0];

    const hour = timeParts[0];
    const minute = timeParts[1];
    const dst = dateParts[2].split(' ')[2];

    let newDateStr = `${month}/${day}/${year} ${hour}:${minute} ${dst}`;

    let myDate = new Date(newDateStr);
    return myDate.getTime();
  } else {
    let myDate = new Date(cstCorrection);
    return myDate.getTime();
  }
}

export function convertDateToStr(mydate) {
  let cstCorrection = mydate.toString();
  if (cstCorrection.indexOf('T') > 0) {
    if (isDstObserved()) {
      cstCorrection = cstCorrection.replace('T', ' ').replace('Z', ' ') + 'CDT';
    } else {
      cstCorrection = cstCorrection.replace('T', ' ').replace('Z', ' ') + 'CST';
    }
  }
  return cstCorrection;
}

function isDstObserved() {
  const nowChicago = moment().tz('America/Chicago').utcOffset();
  return nowChicago !== -360;
}
